/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_launchpad__zois_notification = /** @type {(inputs: {}) => string} */ () => {
	return `Geben Sie einen Start und eine Ankunft ein, um die vorgeschlagenen Zwischenstopps zu finden`
};

const en_launchpad__zois_notification = /** @type {(inputs: {}) => string} */ () => {
	return `Enter a departure and an arrival to find suggested stopovers`
};

const es_launchpad__zois_notification = /** @type {(inputs: {}) => string} */ () => {
	return `Introduzca una salida y una llegada para encontrar las escalas propuestas`
};

const fr_launchpad__zois_notification = /** @type {(inputs: {}) => string} */ () => {
	return `Entrez un départ et une arrivée pour retrouver les escales suggérées`
};

const it_launchpad__zois_notification = /** @type {(inputs: {}) => string} */ () => {
	return `Inserire una partenza e un arrivo per trovare gli scali suggeriti`
};

const nl_launchpad__zois_notification = /** @type {(inputs: {}) => string} */ () => {
	return `Voer een vertrek en een aankomst in om de voorgestelde tussenstops te vinden`
};

const pt_launchpad__zois_notification = /** @type {(inputs: {}) => string} */ () => {
	return `Introduza uma partida e uma chegada para encontrar as escalas sugeridas`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const launchpad__zois_notification = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.launchpad__zois_notification(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("launchpad__zois_notification", locale)
	if (locale === "de") return de_launchpad__zois_notification(inputs)
	if (locale === "en") return en_launchpad__zois_notification(inputs)
	if (locale === "es") return es_launchpad__zois_notification(inputs)
	if (locale === "fr") return fr_launchpad__zois_notification(inputs)
	if (locale === "it") return it_launchpad__zois_notification(inputs)
	if (locale === "nl") return nl_launchpad__zois_notification(inputs)
	return pt_launchpad__zois_notification(inputs)
};